import { BrowserModule } from '@angular/platform-browser';
import {LOCALE_ID, NgModule} from '@angular/core';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
// App Modules
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HomePageComponent } from './home-page/home-page.component';
import { SharedModule } from './shared/shared.module';

// Firebase imports
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { ServiceWorkerModule } from '@angular/service-worker';
import {NavService} from './shared/shell/nav.service';
import {SwiperModule} from 'ngx-swiper-wrapper';
import { LanguagesComponent } from './languages/languages.component';
import { ListMenuComponent } from './list-menu/list-menu.component';
import { DetailsComponent } from './list-menu/details/details.component';

registerLocaleData(localeEs);

@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,
    ListMenuComponent,
    DetailsComponent
  ],
  imports: [
    BrowserModule.withServerTransition({appId: 'serverApp'}),
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    SwiperModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireAuthModule,
    ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production}),
  ],
  providers: [NavService, {provide: LOCALE_ID, useValue: 'es_ES'}],
  bootstrap: [AppComponent]
})
export class AppModule { }
